import Vue from 'vue'
import affirm from './affirm.vue'

let affirmConstructor = Vue.extend(affirm)

let theConfirm = function(optios) {// options为调用方法时传入的数据
  return new Promise((res, rej) => {
    // promise封装， ok执行resolve, close 执行reject
    let confirmDom = new affirmConstructor({
      el: document.createElement('div')
    })
    document.body.appendChild(confirmDom.$el)// new一个对象，插入到body
    confirmDom.content = optios// 为了是confirm扩展性更强，采用对象的形式传入参数
    confirmDom.ok = function() {
      res()
      confirmDom.isShow = false
    }
    confirmDom.close = function() {
      rej()
      confirmDom.isShow = false
    }
  })
}

export default theConfirm
